<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- 遮罩 -->
    <div class="absolute inset-0 bg-black/50" @click="$emit('close')"></div>

    <!-- 模态框 -->
    <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-sm mx-4" style="animation: slideIn 0.2s ease-out;">
      <div class="p-6 text-center">
        <!-- 图标 -->
        <div class="w-12 h-12 mx-auto mb-4 text-red-500">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
        </div>

        <!-- 标题 -->
        <h3 class="text-lg font-semibold text-slate-900 mb-2">{{ title }}</h3>

        <!-- 消息 -->
        <p class="text-sm text-slate-500 mb-6">{{ message }}</p>

        <!-- 按钮 -->
        <div class="flex items-center justify-center gap-3">
          <button
            @click="$emit('close')"
            class="px-4 py-2 bg-white border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-50 transition-colors cursor-pointer"
          >
            取消
          </button>
          <button
            @click="$emit('confirm')"
            class="px-4 py-2 bg-red-600 text-white rounded-lg text-sm hover:bg-red-700 transition-colors cursor-pointer"
          >
            确定删除
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '确定要删除吗？'
  },
  message: {
    type: String,
    default: '删除后无法恢复，请确认是否删除。'
  }
})

defineEmits(['close', 'confirm'])
</script>

<style scoped>
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
